import { useState, useEffect } from "react";
import DiasCalendario from "./DiaCalendario";
import { withStyles } from '@material-ui/core/styles';
import { Grid, TableContainer, TableHead, TableRow, Paper, Table, TableBody, TableCell } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import PickerMod from '../../../global/PickersMod';
import {obtenerCalendarioAction} from "./../../../ducks/viajeCalendarioDuck";
import {format} from "date-fns";
import BackDrop from "../../../global/BackDrop";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 8,
  },
}))(TableCell);

const columns = [
  { id: "do", minWidth: 150, align: "center", label: "do." },
  { id: "lu", minWidth: 150, align: "center", label: "lu." },
  { id: "ma", minWidth: 150, align: "center", label: "ma." },
  { id: "mi", minWidth: 150, align: "center", label: "mi." },
  { id: "ju", minWidth: 150, align: "center", label: "ju." },
  { id: "vi", minWidth: 150, align: "center", label: "vi." },
  { id: "sa", minWidth: 150, align: "center", label: "sa." },
];
const GCalendario = () => {
  const semanas = useSelector(store => store.calendario.semanas); 
  const [fecha, setFecha] = useState(new Date());
  const [load, setLoad] = useState(false)
  const dispatch = useDispatch();
  
  useEffect(() =>{
    setLoad(true)
    dispatch(obtenerCalendarioAction(format(fecha, "yyyy"), format(fecha, "MM"))).then(Response => {
      setLoad(false)
    });
  },[dispatch, fecha]);

  return (
    <Grid container>
      <Grid item xs={6}>
        <PickerMod
          selectedDate={fecha}
          views={["year", "month"]}
          formatFecha="MM/yyyy"
          label="Fecha"
          disablePast={false}
          setSelectedDate={setFecha}
        />
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table size="medium" aria-label=" table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <StyledTableCell key={column.id}>{column.label}</StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {semanas.map((semana, i) => (
                <DiasCalendario
                  key={i + 1}
                  row={semana}
                  MesActual={format(fecha, "MM")}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <BackDrop open={load} />
    </Grid>
  );
};
export default GCalendario;
